import { composeU } from '@bem-react/core';

import BaseLevel from 'client/common/components/level';

import { withLevelTypeAboutCompany } from './_type/level_type_aboutCompany';
import { withLevelTypeAbstract } from './_type/level_type_abstract';
import { withLevelTypeAdvice } from './_type/level_type_advice';
import { withLevelTypeAgency } from './_type/level_type_agency';
import { withLevelTypeAnnotatedImage } from './_type/level_type_annotatedImage';
import { withLevelTypeCarousel } from './_type/level_type_carousel';
import { withLevelTypeCta } from './_type/level_type_cta';
import { withLevelTypeDataSummary } from './_type/level_type_dataSummary';
import { withLevelTypeDownload } from './_type/level_type_download';
import { withLevelTypeFilters } from './_type/level_type_filters';
import { withLevelTypeLikeYesNo } from './_type/level_type_likeYesNo';
import { withLevelTypeMarkedText } from './_type/level_type_markedText';
import { withLevelTypeMarkedText2 } from './_type/level_type_markedText2';
import { withLevelTypeMedia } from './_type/level_type_media';
import { withLevelTypeNote } from './_type/level_type_notes';
import { withLevelTypeQuote } from './_type/level_type_quote';
import { withLevelTypeResults } from './_type/level_type_results';
import { withLevelTypeResults2 } from './_type/level_type_results2';
import { withLevelTypeResumeLines } from './_type/level_type_resume_lines';
import { withLevelTypeSolutionHeader } from './_type/level_type_solution_header';
import { withLevelTypeSolutionRecommendations } from './_type/level_type_solution_recommendations';
import { withLevelTypeStructuredInfo } from './_type/level_type_structured_info';
import { withLevelTypeThumb } from './_type/level_type_thumb';
import { withLevelTypeVideo } from './_type/level_type_video';
import './index.css';

const Level = composeU(
    withLevelTypeAbstract,
    withLevelTypeAboutCompany,
    withLevelTypeAdvice,
    withLevelTypeAnnotatedImage,
    withLevelTypeDataSummary,
    withLevelTypeDownload,
    withLevelTypeAgency,
    withLevelTypeQuote,
    withLevelTypeFilters,
    withLevelTypeLikeYesNo,
    withLevelTypeMedia,
    withLevelTypeResults,
    withLevelTypeResults2,
    withLevelTypeCta,
    withLevelTypeCarousel,
    withLevelTypeStructuredInfo,
    withLevelTypeThumb,
    withLevelTypeMarkedText,
    withLevelTypeMarkedText2,
    withLevelTypeNote,
    withLevelTypeVideo,
    withLevelTypeResumeLines,
    withLevelTypeSolutionRecommendations,
    withLevelTypeSolutionHeader
)(BaseLevel);

export default Level;
